// src/pages/DocsGate.jsx
import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import NavBar from '../components/NavBar';
import GoogleLoginButton from '../components/GoogleLoginButton';
import { User, Lock } from 'lucide-react';

const colors = {
  accent: '#1e40af',
  accentHover: '#1e3a8a',
  accentLight: 'rgba(30, 64, 175, 0.1)',
  white: '#ffffff',
  gray50: '#f9f9f9',
  gray100: '#f3f3f3',
  gray200: '#e6e6e6',
  gray300: '#d1d1d1',
  gray500: '#8e8e8e',
  gray700: '#636363',
  gray900: '#333333',
};
const fontStyles = {
  fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
  heading: { fontWeight: 500, letterSpacing: '-0.03em' },
  body: { fontWeight: 400, letterSpacing: '-0.01em' },
  medium: { fontWeight: 500 },
};

const DocsGate = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      window.location.assign('https://docs.signpact.ai/introduction');
    }
  }, [user]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <NavBar />
      <div
        className="flex-1 flex items-center justify-center px-6 py-12"
        style={{ fontFamily: fontStyles.fontFamily, backgroundColor: colors.white, minHeight: 'calc(100vh - 100px)' }}
      >
        <div className="w-full max-w-md mx-auto" style={{ width: '100%', maxWidth: '400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          {/* Header Section - match login */}
          <div className="text-center mb-10">
            <h1
              className="text-4xl font-bold mb-4 flex items-center justify-center"
              style={{ color: colors.gray900, ...fontStyles.heading, lineHeight: '1.1' }}
            >
              Get started with
              <img src="/6.png" alt="SignPact Logo" className="h-12 ml-2" style={{ marginTop: '4px' }} />
            </h1>
          </div>

          {/* Highlighted notice */}
          <div
            className="mb-6 rounded-xl px-4 py-3 flex items-center justify-center text-center"
            style={{ backgroundColor: colors.accentLight, border: `1px solid ${colors.accent}`, color: colors.accent }}
            aria-live="polite"
          >
            <Lock size={18} className="mr-2" />
            <span className="text-sm font-medium">Only signed‑in users can access the SignPact documentation.</span>
          </div>

          {/* Buttons - same arrangement as login */}
          <div className="space-y-4 mb-6">
            <GoogleLoginButton className="w-full" />

            <div className="relative flex items-center justify-center my-6">
              <div className="border-t absolute w-full" style={{ borderColor: colors.gray200 }} />
              <span className="bg-white px-4 text-sm relative" style={{ color: colors.gray500, fontSize: '14px' }}>OR</span>
            </div>

            <button
              onClick={() => navigate('/login/credentials')}
              className="w-full py-3 px-6 rounded-xl font-medium flex items-center justify-center"
              style={{ backgroundColor: colors.white, color: colors.gray900, border: '1px solid #e6e6e6', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', transition: 'all 0.2s ease', ...fontStyles.medium }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f9f9f9'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = colors.white; }}
            >
              <User size={20} className="mr-2" />
              Continue with Email
            </button>
          </div>

          {/* Spacer to align with login layout */}
          <div className="mb-6" />

          {/* Footer Section - same legal text */}
          <div className="text-center">
            <p className="text-xs leading-relaxed" style={{ color: colors.gray500, fontSize: '12px' }}>
              By clicking continue, you agree to our{' '}
              <Link to="/terms" className="underline hover:no-underline" style={{ color: colors.accent }}>
                Terms of Service
              </Link>{' '}and{' '}
              <Link to="/privacy" className="underline hover:no-underline" style={{ color: colors.accent }}>
                Privacy Policy
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocsGate;

